import axios from 'axios'
import store from '../../store';
import RomeError from "./rome-error";
import fileDownload from 'js-file-download';
import {config} from "../../config";
import {toastService} from "./toast-service";
import auth from '../../auth'


export class RomeApi {
    constructor() {}

    init(baseUrl) {
      this.baseURL = baseUrl;
      this.api = axios.create({
        baseURL: this.baseURL
      });

      this.api.interceptors.request.use(cfg => {
        let loggedIn = store.getters['session/loggedIn'];
        let apiToken = store.state.session.apiToken;
        let impersonatedUserId = store.state.session.impersonatedUser ? store.state.session.impersonatedUser.userId : null;
        if(loggedIn) {
          cfg.headers.Authorization = `Bearer ${apiToken}`;
          if(impersonatedUserId) {
            cfg.headers.Impersonating = impersonatedUserId;
          }
        }
        return cfg;
      });

      this.api.interceptors.response.use(response => response, async (error) => {
        const data = error.response ? error.response.data : { ErrorMessage: "Error" };
        const message = data.ErrorMessage || data.exceptionMessage || data.messageDetail || data.statusText || '';

        if (error.response && error.response.status === 401 && _.isString(message) && _.includes(message.toLowerCase(), 'not logged in')) {
          return await this.handle401NotLoggedIn(error);
        } else if (error.request.responseType === 'blob' && error.response && error.response.status === 500) {
          return await this.handleDownloadError(error);
        } else {
          return await this.handleGeneralError(error);
        }
      });
    }

    async handle401NotLoggedIn(error) {
      await auth.logoutWithMessageSessionExpired();
      throw error;
    }

    async handleDownloadError(error) {
      const arrayBuffer = await error.response.data.arrayBuffer();
      const json = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
      const serverError = JSON.parse(json);
      const err = {};
      err.message = serverError.ErrorMessage;
      const romeError = new RomeError(err);
      setTimeout(() => {
        if (!romeError._handled) {
          toastService.error(romeError.message);
        }
      }, 500);
      throw romeError;
    }

    async handleGeneralError(error) {
      const romeError = new RomeError(error);
      setTimeout(() => {
        if (!romeError._handled) {
          toastService.error(romeError.message);
        }
      }, 500);
      throw romeError;
    }

    isJsonDateString(date) {
      return _.isString(date) && date.match(/^\d{4}\-\d{2}-\d{2}\T/);
    }

    processJsonData(data) {
        _.keys(data).forEach(p => {
            if (data[p]) {
                if (_.isDate(data[p]) || this.isJsonDateString(data[p])) {
                    data[p] = moment(data[p]).format("YYYY-MM-DD");
                } else if (data[p].isSameOrAfter) {
                    data[p] = data[p].format("YYYY-MM-DD");
                } else if (_.isObject(data[p])) {
                    this.processJsonData(data[p]);
                }
            }
        })
    }

    async get(relativeUrl, data) {
        this.processJsonData(data);
        var response = await this.api.get(relativeUrl, { params: data });
        return response.data;
    }

  async download(relativeUrl, filename, data){
      this.processJsonData(data);
      let cfg = {
          params: data,
          responseType: 'blob'
      };
      var response =  await this.api.get(relativeUrl, cfg);

      filename = getFileName(response, filename);
      fileDownload(response.data, filename);
    }

    async generate(relativeUrl, filename, data){
      this.processJsonData(data);
      let cfg = {responseType: 'blob'}
      var response = await this.api.post(relativeUrl, data, cfg);

      filename = getFileName(response, filename);
      fileDownload(response.data, filename);
    }

    async post(relativeUrl, data) {
      this.processJsonData(data);
      var response = await this.api.post(relativeUrl, data);
      return response.data;
    }

    async put(relativeUrl, data) {
      this.processJsonData(data);
      var response = await this.api.put(relativeUrl, data);
      return response.data;
    }

    async patch(relativeUrl, data) {
      this.processJsonData(data);
      var response = await this.api.patch(relativeUrl, data);
      return response.data;
    }

    async postDownload(relativeUrl, filename, data) {
        this.processJsonData(data);

        var response = await this.api.post(relativeUrl, data);

        filename = getFileName(response, filename);
        fileDownload(response.data, filename);
    }

    async upload(relativeUrl, data) {
      let response = await this.api.post(relativeUrl, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: async (progressEvent) => {
            const percent = Math.round( (progressEvent.loaded * 100) / progressEvent.total);
            store.commit('progress/set', percent);
          },
      }).finally(() => {
        store.commit('progress/hide');
      });

      return response.data;
    }

    async delete(relativeUrl) {
      var response = await this.api.delete(relativeUrl, { params: { } });
      return response.data;
    }

}

const romeApi = new RomeApi();

romeApi.init('http://localhost:5000/');

export { romeApi }

function getFileName(response, filename){
    let contentDisposition = response.headers['content-disposition'];
    if(!filename && contentDisposition){
        var index = contentDisposition.indexOf("filename=");
        if(contentDisposition.length > index + 9){
            filename = contentDisposition.substring(index + 9);
        }
    }
    if(!filename) throw "Either the API must provide a filename or download must be called with a filename argument.";
    return filename;
}



// WEBPACK FOOTER //
// ./src/framework/utils/rome-api.js